import axios from 'axios';
import router from '@/router';

const axiosDefaultConfig = {
    baseURL: process.env.VUE_APP_API_URL
}

const instance = axios.create(axiosDefaultConfig)

instance.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token')

    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    config.headers['Accept-Language'] = localStorage.getItem('locale') || 'en';

    return config
}, function (error) {
    return Promise.reject(error)
});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        localStorage.clear();
        router.push({ name: 'login' });
        return;
    }

    // TODO: verificar necessidade de tratar o http code 500
    // TODO: verificar necessidade de tratar network error (falha de comunicação com servidor)

    return Promise.reject(error);
});

const api = {}

for (const method of ['request', 'delete', 'get', 'head', 'options', 'post', 'put', 'patch']) {
    api[method] = function () { return instance[method].apply(null, arguments).then(res => res && res.data) }
}

export default api;